import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getVoteNum, vote, requestTongji } from '../../../../../../services/api';
import errorBoundary from '@ifeng/errorBoundary';

class Vote extends React.PureComponent {
    state = {
        isVoted: false,
        voteNum: 0,
    };

    async componentDidMount() {
        try {
            const { url } = this.props;

            const data = await getVoteNum(`${url}ding`);

            this.setState({ voteNum: data.browse[`${url}ding`] });
        } catch (e) {
            console.error(e);
        }
    }

    vote = async () => {
        try {
            const { isVoted } = this.state;

            if (isVoted) {
                return;
            }

            const { url } = this.props;

            const data = await vote(`${url}ding`);

            if (data) {
                const voteNum = await getVoteNum(`${url}ding`);

                this.setState({
                    isVoted: !isVoted,
                    voteNum: voteNum.browse[`${url}ding`],
                });
            }
            requestTongji('pic', 'laud');
        } catch (e) {
            console.error(e);
        }
    };

    /**
     * 渲染网页布局
     */

    render() {
        const { isVoted, voteNum } = this.state;
        // console.log(this.props);

        return (
            <li className={isVoted ? styles.change : styles.good} onClick={this.vote}>
                {voteNum}
            </li>
        );
    }
}

export default errorBoundary(Vote);
